var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.25012C10.1396 5.25012 9.17004 5.85343 8.65132 6.75013H12.75C15.2353 6.75013 17.25 8.76485 17.25 11.2501V15.3488C18.1467 14.83 18.75 13.8605 18.75 12.7501V8.25012C18.75 6.59327 17.4068 5.25012 15.75 5.25012H11.25ZM5.25 11.2501C5.25 9.59326 6.59315 8.25011 8.25 8.25011H12.75C14.4069 8.25011 15.75 9.59326 15.75 11.2501V15.7501C15.75 17.407 14.4069 18.7501 12.75 18.7501H8.25C6.59315 18.7501 5.25 17.407 5.25 15.7501V11.2501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.0d310c64c65659bb50968902842a128c.svg";
export { ForwardRef as ReactComponent };